import { render, staticRenderFns } from "./MipLabels.vue?vue&type=template&id=f6a3415a&"
import script from "./MipLabels.vue?vue&type=script&lang=ts&"
export * from "./MipLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports